import {
  Component,
  DoCheck,
  HostListener,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { UserProfileService } from "../../user-profile.service";
import { TranslateService } from "@ngx-translate/core";
import { Title } from '@angular/platform-browser';
import { ModalService } from "@app/services/modal/modal.service";
import { ServiceConfigService } from "@app/services/service-config.service";

@Component({
    selector: "nh-uploaded-documents",
    templateUrl: "./uploaded-documents.component.html",
    styleUrls: ["./uploaded-documents.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UploadedDocumentsComponent implements OnInit, DoCheck {
  screenHeight: number;
  screenWidth: number;
  isMobileView = false;
  mobileWidth = 480;
  rows = [];
  imeRows = [];
  wpAppNum;
  columns = [
    { name: "Name", prop: "name" },
    { name: "Type of Proof", prop: "proofType" },
    { name: "Verification For", prop: "verificationFor" },
    { name: "Document Type", prop: "docType" },
    { name: "Upload Date", prop: "uploadDt" },
  ];
  imeColumns = [
    { name: "Name", prop: "name" },
    { name: "Incurred Medical Expense Type", prop: "expenseType" },
    { name: "Document Type", prop: "docType" },
    { name: "Upload Date", prop: "uploadDt" },
  ];
  memberUploadDocColumns = [
    { name: "Name", prop: "name" },
    { name: "Uploaded By", prop: "uploadedBy" },
    { name: "Type of Proof", prop: "proofType" },
    { name: "Verification For", prop: "verificationFor" },
    { name: "Document Type", prop: "docType" },
    { name: "Upload Date", prop: "uploadDt" },
  ];
  translatedLang;
  defaultLanguage;
  individualId;
  hasNoIndvId = sessionStorage.getItem("individualId") === "null" ? true : false;
  user = sessionStorage.getItem('userType');
  viewTCC = JSON.parse(sessionStorage.getItem('ViewTCC'));
  ppViewTcc = (this.user === 'RP' && this.viewTCC);
  readTCC = sessionStorage.getItem('ReadTCC') === 'true' ? true : false;
  wpAppNumInSession = sessionStorage.getItem('wpAppNum');
  memberUploadedDocRows = [];
  memberPersonId;
  isPartnerApp: boolean = false;
  organizationName: string;
  partnerOrgDocSwitch: boolean = false;
  constructor(private userProfileService: UserProfileService, private route: ActivatedRoute, public translateService: TranslateService, private titleService: Title,private modalService: ModalService,
    private serverConfig: ServiceConfigService
    ) {
    this.getScreenSize();
    this.getReturnValueWP();
    this.titleService.setTitle('My Documents | Uploaded Documents');
  }

  @HostListener("window:resize")
  getScreenSize() {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
  }

  getReturnValueWP() {
    this.route.params.subscribe((params) => {
      if (params["wpAppNum"]) {
        this.wpAppNum = params["wpAppNum"];
        this.userProfileService.getUploadedDocsByTNum(params["wpAppNum"]).subscribe((res: any) => {
          const rowData = { ...res };
          this.organizationName = rowData?.orgName;
          this.rows = rowData?.uploadedDocuments?.map((val) => {
            const arr = val.uploadDt.split("-");
            return this.getTableValues(val, arr);
          });
        });
      }
      else if(this.wpAppNumInSession){
        this.userProfileService.getUploadedDocsByTNum(this.wpAppNumInSession).subscribe((res: any) => {
          const rowData = { ...res };
          this.organizationName = rowData?.orgName;
          this.rows = rowData?.uploadedDocuments?.map((val) => {
            const arr = val.uploadDt.split("-");
            return this.getTableValues(val, arr);
          });
        });
      }
    });
  }

  getReturnValueNoWP() {
    if (!this.wpAppNum && !this.wpAppNumInSession) {
      const userType = sessionStorage.getItem("userType");
      if (userType === "RP") {
        this.individualId = sessionStorage.getItem("individualId");
        this.individualId = this.individualId === "null" ? "" : this.individualId;
      }
      const entityId = sessionStorage.getItem('mtlToken');
      this.userProfileService.getUploadedDocuments(this.individualId, encodeURIComponent(entityId)).subscribe((res: any) => {
        const rowData = { ...res };
        this.organizationName = rowData?.orgName;
        this.rows = rowData?.uploadedDocuments?.map((val) => {
          const arr = val.uploadDt.split("-");
          return this.getTableValues(val, arr);
        });
        this.imeRows = rowData?.uploadedExpenseProofs?.map((val) => {
          return this.getIMETableValues(val);
        });

        this.memberUploadedDocRows = rowData?.memberUploadedDocuments?.map((val) =>{
          const arr = val?.uploadDt.split("-");
          return this.getMemberUplaodDocTableValues(val, arr);
        })
        this.memberPersonId = sessionStorage.getItem('individualId')
      });
    }
  }

  getIMETableValues(val) {
    let retValue;
      retValue = {
        name: val?.name,
        expenseType: val?.expenseType?.value,
        docType: val?.documentType?.value,
        uploadDt: val?.uploadDt,
        docId: val?.fnDocumentId ? val?.fnDocumentId : val?.uploadDocId,
      };
    return retValue;
  }

  getTableValues(val, arr) {
    let retValue;
    if (this.translatedLang === "en") {
      retValue = {
        name: val?.name,
        uploadedBy: val?.updatedByUserName,
        proofType: val?.typeOfProof?.value,
        verificationFor: val?.verificationFor?val?.verificationFor:'N/A',
        docType: val?.documentType?.value,
        uploadDt: `${arr[1]}/${arr[2]}/${arr[0]}`,
        docId: val?.fnDocumentId ? val?.fnDocumentId : val?.uploadDocId,
        pageCount : val?.pageCount
      };
    } else {
      retValue = {
        name: val?.name,
        uploadedBy: val?.updatedByUserName,
        proofType: val?.typeOfProof?.spValue,
        docType: val?.documentType?.spValue,
        verificationFor: val?.verificationFor? this.userProfileService.findSpTransalation(val?.verificationFor):'N/A',
        uploadDt: `${arr[1]}/${arr[2]}/${arr[0]}`,
        docId: val?.fnDocumentId ? val?.fnDocumentId : val?.uploadDocId,
        pageCount : val?.pageCount
      };
    }
    return retValue;
  }

  getMemberUplaodDocTableValues(val, arr) {
    let retValue;
    retValue = {
      name: val?.name,
      uploadedBy: val?.updatedByUserName,
      proofType: val?.typeOfProof?.value,
      verificationFor: val?.verificationFor?val?.verificationFor:'N/A',
      docType: val?.documentType?.value,
      uploadDt: `${arr[1]}/${arr[2]}/${arr[0]}`,
      docId: val?.fnDocumentId ? val?.fnDocumentId : val?.uploadDocId,
      pageCount : val?.pageCount
    };

    return retValue;
  }

  ngDoCheck() {
    this.isMobileView = this.screenWidth <= this.mobileWidth;
  }

  ngOnInit() {
    const accountType = sessionStorage.getItem("userType");
    this.isPartnerApp = accountType === "RP" ? true : false;
    this.partnerOrgDocSwitch = this.serverConfig.getServerConfig().PP_ORG_DOC_SW;
    if (this.isPartnerApp && this.partnerOrgDocSwitch) {
      this.columns.splice(1, 0, { name: "Uploaded By", prop: "uploadedBy" });
    }
    this.defaultLanguage = this.translateService.getDefaultLang();
    this.translatedLang = this.defaultLanguage;
    this.translateService.onDefaultLangChange.subscribe((res) => {
      this.translatedLang = res.lang;
      this.getReturnValueWP();
      this.getReturnValueNoWP();
    });
    this.getReturnValueNoWP();
  }

  showPdf(row) {
    console.log('---row---', row);
    const docId = row.docId?.replace(/[{}]/g, "");
    this.userProfileService.getPrintDoc(docId, 'TCCUD').subscribe((res: any) => {
      const file = new Blob([res], { type: "application/pdf" });
      let newVariable: any;
      newVariable = window.navigator;
      if (newVariable && newVariable.msSaveOrOpenBlob) {
        newVariable.msSaveOrOpenBlob(file);
      } else {
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      }
    });
  }

  docUploadInfo() {
    this.modalService.openDocUploadFaqs().subscribe();
  }
  
}
